export default __webpack_public_path__ + "static/media/EditarIconBlue.e451afc6.svg";